import i18n from '../../i18n'
import requiredRules from './requiredRules'

const hasJdbcTemplateRule = (textContent) => {
  const hasClassInstance = /JdbcTemplate\.class/.test(textContent)
  const hasClassInstanceByClassLoader = /Class\s*\.\s*forName\s*\([^)]*JdbcTemplate[^)]*\)/.test(textContent)
  return hasClassInstance || hasClassInstanceByClassLoader
}

const hasMlogIgnore = (testContent) => /\.\s*setIgnore(Log|Info|Debug)\s*\(/.test(testContent)

const hasGetBean = (textContent) => /getBean\s*\([^)]*\)/.test(textContent)

const usingDangerousMethods = (value) => [
  hasJdbcTemplateRule(value),
  hasMlogIgnore(value),
  hasGetBean(value)
]

const dangerousCodeInputApiRules = (value, required) => [
  required && requiredRules(value),
  !usingDangerousMethods(value).includes(true) || i18n.t('warnings.validation.internal_api')
]

export default dangerousCodeInputApiRules
